import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { api } from '../../api';

export default function BOClients() {
  const { standId } = useParams();
  const [clients, setClients] = useState([]);
  const [selectedClient, setSelectedClient] = useState(null);
  const [history, setHistory] = useState([]);
  const [showCampaign, setShowCampaign] = useState(false);
  const [campaignMsg, setCampaignMsg] = useState('');
  const [campaignResult, setCampaignResult] = useState(null);
  const [copied, setCopied] = useState('');

  useEffect(() => {
    api.getStandClients(standId).then(setClients);
  }, [standId]);

  const viewHistory = async (client) => {
    setSelectedClient(client);
    const h = await api.getClientHistory(client.id);
    setHistory(h);
  };

  const copyToClipboard = (text, label) => {
    navigator.clipboard.writeText(text);
    setCopied(label);
    setTimeout(() => setCopied(''), 2000);
  };

  const exportCSV = () => {
    const header = 'Prenom,Nom,Email,Telephone,Commandes,Depense totale\n';
    const rows = clients.map(c =>
      `${c.prenom},${c.nom},${c.email},${c.telephone},${c.nb_commandes},${c.total_depense?.toFixed(2)}`
    ).join('\n');
    const blob = new Blob([header + rows], { type: 'text/csv' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'clients_stand.csv';
    a.click();
  };

  const sendCampaign = async () => {
    const result = await api.createCampaign(standId, { contenu_message: campaignMsg, cible: 'tous' });
    setCampaignResult(result);
    setCampaignMsg('');
  };

  return (
    <div>
      <div className="flex items-center justify-between mb-6">
        <h1 className="font-serif text-[#332A1C] text-2xl">CRM Clients</h1>
        <div className="flex gap-2">
          <button onClick={exportCSV} className="border border-[#E2D1B8] text-[#8B7355] px-4 py-2 rounded-lg text-sm font-medium hover:bg-[#F9EDDA] hover:text-[#332A1C] transition">
            Exporter CSV
          </button>
          <button onClick={() => setShowCampaign(!showCampaign)} className="bg-[#C4673D] text-white px-4 py-2 rounded-lg text-sm font-bold hover:bg-[#C4673D]/90 transition">
            Campagne
          </button>
        </div>
      </div>

      {/* Campagne */}
      {showCampaign && (
        <div className="bg-white rounded-xl shadow-sm p-4 mb-6 border-l-4 border-[#C4673D]">
          <h3 className="font-serif font-bold text-[#332A1C] mb-2 text-sm">Nouvelle campagne</h3>
          <textarea value={campaignMsg} onChange={e => setCampaignMsg(e.target.value)}
            placeholder="Message de la campagne..." rows={3}
            className="w-full bg-white border border-[#E2D1B8] rounded-lg px-4 py-2.5 mb-3 text-[#332A1C] placeholder-[#8B7355]/50 focus:border-[#C4673D] focus:outline-none" />
          <button onClick={sendCampaign} disabled={!campaignMsg}
            className="bg-[#C4673D] text-white px-4 py-2 rounded-lg text-sm font-bold hover:bg-[#C4673D]/90 transition disabled:opacity-50">
            Envoyer (simulation)
          </button>
          {campaignResult && (
            <p className="mt-2 text-sm text-[#6B7F3B]">{campaignResult.message}</p>
          )}
        </div>
      )}

      {copied && (
        <div className="fixed top-4 right-4 bg-[#C4673D] text-white px-4 py-2 rounded-lg text-sm font-bold z-50">
          {copied} copié !
        </div>
      )}

      <div className="grid gap-4 lg:grid-cols-2">
        {/* Liste clients */}
        <div>
          <div className="bg-white rounded-xl shadow-sm divide-y divide-[#E2D1B8]/50">
            {clients.length === 0 ? (
              <div className="p-8 text-center text-[#8B7355]">Aucun client</div>
            ) : clients.map(client => (
              <div key={client.id}
                className={`p-4 cursor-pointer hover:bg-[#FEFCF8] transition ${selectedClient?.id === client.id ? 'border-l-2 border-[#C4673D] bg-[#FEFCF8]' : 'border-l-2 border-transparent'}`}
                onClick={() => viewHistory(client)}
              >
                <div className="flex items-center justify-between">
                  <div>
                    <p className="font-medium text-[#332A1C]">{client.prenom} {client.nom}</p>
                    <div className="flex items-center gap-3 mt-1">
                      <button onClick={(e) => { e.stopPropagation(); copyToClipboard(client.email, 'Email'); }}
                        className="text-xs text-[#C4673D] hover:underline" title="Copier l'email">
                        {client.email}
                      </button>
                      <button onClick={(e) => { e.stopPropagation(); copyToClipboard(client.telephone, 'Téléphone'); }}
                        className="text-xs text-[#C4673D] hover:underline" title="Copier le téléphone">
                        {client.telephone}
                      </button>
                    </div>
                  </div>
                  <div className="text-right">
                    <p className="text-sm font-medium text-[#332A1C]">{client.total_depense?.toFixed(2)} &euro;</p>
                    <p className="text-xs text-[#8B7355]">{client.nb_commandes} cmd(s)</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Historique */}
        <div>
          {selectedClient ? (
            <div className="bg-white rounded-xl shadow-sm p-4">
              <h3 className="font-serif font-bold text-[#332A1C] mb-3 text-sm">
                Historique — {selectedClient.prenom} {selectedClient.nom}
              </h3>
              <p className="text-sm text-[#8B7355] mb-3">Points fidélité : <span className="text-[#C4673D] font-medium">{selectedClient.points_fidelite}</span></p>
              {history.length === 0 ? (
                <p className="text-[#8B7355] text-sm">Aucune commande</p>
              ) : history.map(order => (
                <div key={order.id} className="border-b border-[#E2D1B8]/50 last:border-0 py-3">
                  <div className="flex justify-between text-sm">
                    <span className="font-medium text-[#332A1C]">Commande #{order.id}</span>
                    <span className="text-[#8B7355]">{new Date(order.date_commande).toLocaleDateString('fr-FR')}</span>
                  </div>
                  <div className="mt-1 space-y-0.5">
                    {order.items.map(item => (
                      <p key={item.id} className="text-xs text-[#8B7355]">{item.quantite}x {item.product_nom}</p>
                    ))}
                  </div>
                  <p className="text-sm font-medium text-right mt-1 text-[#332A1C]">{order.total_ttc.toFixed(2)} &euro;</p>
                </div>
              ))}
            </div>
          ) : (
            <div className="bg-white rounded-xl shadow-sm p-8 text-center text-[#8B7355]">
              <p>Sélectionnez un client pour voir son historique</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
